import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { exportFile } from 'src/app/shared/utils/export-file.function';
import { environment } from 'src/environments/environment';
import { DeclarationService } from '../../services/forms.service';

@Component({
  selector: 'app-form6',
  templateUrl: './form6.component.html',
  styleUrls: ['./form6.component.css']
})

export class Form6Component implements OnInit {
  filePath = environment.FilePath;
  docSizeError: boolean;
  fileType: any;
  docName: any;
  ClientNo: string;
  uploadedFilesList = [];
  FormsData: any;
  clientsData: any;
  remarks: any;
  Form6Data: any;
  finaldeclarationData : any;
  today = new Date();
  msgErrorNotSaved: boolean;
  isDataEntered: boolean;
  downloadError: boolean;
  filesEmptyError: boolean;
  imageFormatError: boolean;
  fileSize5mbError: boolean;

  constructor(private declarationService: DeclarationService,private _router: Router) {

  }
  isShow: boolean = false;
  ngOnInit(): void {
    this.FormsData = JSON.parse(sessionStorage.getItem("FormsData"));
    // let selectedForm = JSON.parse(sessionStorage.getItem("selectedFormData"));
      this.clientsData = JSON.parse(sessionStorage.getItem("SelectedClientData"));
    this.ClientNo = sessionStorage.getItem("ClientNo");
    //  let filesList = sessionStorage.getItem("uploadedFilesList");
  

//Get Saved Data from Cache -
var savedForm6Data = JSON.parse(sessionStorage.getItem("SavedDeclaration6CachedData"));
var isForm6Saved = sessionStorage.getItem('isForm6Saved') == 'true' ? true : false;

if (isForm6Saved && savedForm6Data !== null) {
  var formData;
  savedForm6Data.dataXML.XMLFile.Declaration.forEach(element => {
    if (element.Genre == '6' ) {
      formData = element;
    }
  });
  this.Form6Data = formData;
  if(formData.UploadedDocument != [] && formData.UploadedDocument != null && formData.UploadedDocument != undefined){
    let uploadedDocData = [];
        formData.UploadedDocument.forEach(element => {
          if (element != "" && element != null) {
            uploadedDocData.push(element);
          }
        });
        // if (filesList != "[]" && filesList != null) {
        //   this.uploadedFilesList = JSON.parse(filesList);
        // } else {
          this.uploadedFilesList = uploadedDocData;
          // sessionStorage.setItem("uploadedFilesList",JSON.stringify(this.uploadedFilesList));
        // }
  }
  this.remarks = formData.Comment;
} else {
  var formData;
      if (this.FormsData !== null) {
        this.FormsData.forEach(element => {
          if (element.Genre == '6') {
            formData = element;
          }
        });
      }
      this.Form6Data = formData;
      if (formData.UploadedDocument != [] && formData.UploadedDocument != null && formData.UploadedDocument != undefined) {
        let uploadedDocData = [];
        formData.UploadedDocument.forEach(element => {
          if (element != "" && element != null) {
            uploadedDocData.push(element);
          }
        });
        // if (filesList != "[]" && filesList != null) {
        //   this.uploadedFilesList = JSON.parse(filesList);
        // } else {
          this.uploadedFilesList = uploadedDocData;
          // sessionStorage.setItem("uploadedFilesList",JSON.stringify(this.uploadedFilesList));
        // }
      }
      this.remarks = formData.Comment;
    }

  }
  uploadFile($event) {
    var requestObj = {
      Locale:"",
      Bytes: "",
      FilePath: "",
      FileName: ""
    }
    this.isDataEntered = true;
    this.docSizeError = false;
    this.imageFormatError = false;
    const files = $event.target.files;
    this.fileType = files[0].type;
    if (this.fileType === 'application/pdf' || this.fileType.includes('image/jpeg') 
    || this.fileType.includes('image/jpg') || this.fileType.includes('image/png' )) {
     
      if (files[0].size < 5242880) {
       
      if(this.uploadedFilesList.length < 5){

      this.docName = files[0].name;
      const extension = files[0].name.split('.').pop();
      const reader = new FileReader();
      reader.readAsDataURL(files[0]);

      reader.onload = () => {
        var x = reader.result as string
        var bytes = x.substring(x.indexOf(",") + 1);
        requestObj.Bytes = bytes;
        requestObj.FileName = this.docName;
        var FileName = this.ClientNo + '_' + this.docName;
        requestObj.FilePath = this.filePath + FileName;
        requestObj.Locale = "0";
        this.uploadedFilesList.push(requestObj);
        // sessionStorage.setItem("uploadedFilesList",JSON.stringify(this.uploadedFilesList));
      };
    }else{
      this.docSizeError = true;
    }
  }else{
    this.fileSize5mbError = true;
  }
    } else {
      this.imageFormatError = true;
    }
  }
  downloadPdf(filePath,fileName) {
        var fileExt = fileName.substring(fileName.indexOf(".") + 1);
        var docName = fileName.substring(0,fileName.length-4);
        var obj ={ FilePath : "" };
    this.uploadedFilesList.forEach(item => {
      if (item.Locale == "0" && fileName == item.FileName) {
        exportFile(item.Bytes, 'application/octet-stream', docName, fileExt);
      }else if(fileName == item.FileName && item.Locale == "1"){
        obj.FilePath = filePath;
        this.declarationService.downloadPdfService(obj)
        .subscribe((response) => {
           if (response != "Failed") {
            this.downloadError = false;
             var pdfBytes = JSON.parse(response);
           exportFile(pdfBytes.bytes, 'application/octet-stream', docName, fileExt);
           }else if(response == "Failed"){
             this.downloadError = true;
           }
           else{
             this.downloadError = true;
           }
          },
          (err) => { 
           this.downloadError = true;
          });
      }
    });
    
     }
  deleteUploadedFile(index) {
    this.uploadedFilesList.splice(index, 1);
    // sessionStorage.setItem("uploadedFilesList",JSON.stringify(this.uploadedFilesList));
    this.isDataEntered = true;
  }
  dataEntered() {
      this.isDataEntered = true;
  }
  ValidateAndSaveForm6(){
    if(this.uploadedFilesList.length > 0 || this.remarks){
    this.filesEmptyError = false;
   this.PrepareDeclarationData();
   var Form6JsonSaveDeclaration = JSON.stringify(this.finaldeclarationData);
   var Declaration6Data = JSON.parse(Form6JsonSaveDeclaration);
  this.declarationService.SaveDeclaration1(Declaration6Data).subscribe(
   (data) => {
       if (data == 'Failed') {
       this.msgErrorNotSaved = true;
       sessionStorage.setItem('isForm3Saved', 'false');
       }
       else {
         this.uploadedFilesList.forEach(eachDoc =>{
           if(eachDoc.Locale == "0"){
          this.declarationService.UploadFile(eachDoc).subscribe(
            (data) => {
              var response = data;
              // console.log("Uploaded files",eachDoc,response)
            });

            eachDoc.FilePath = environment.FilePathDocumentum + this.ClientNo + '_' + eachDoc.FileName;
            this.declarationService.UploadFile(eachDoc).subscribe(
              (data) => {
                var response = data;
                // console.log("Uploaded files",eachDoc,response)
              });

          }
         });
         
         sessionStorage.setItem("FormsData", JSON.stringify(this.FormsData));
         sessionStorage.setItem("AllDeclarationData", Form6JsonSaveDeclaration);
         sessionStorage.setItem('isForm6Saved', 'true');
         sessionStorage.setItem("SavedDeclaration6CachedData", Form6JsonSaveDeclaration);
         sessionStorage.setItem('form6SubmittedDate', formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100'));
         this.msgErrorNotSaved = false;
         this.gotoDashboard();
       }
     },
    (err) => {
     this.msgErrorNotSaved = true;
     });
    }else{
      this.filesEmptyError = true;
    }
  }
  gotoDashboard() {
    this._router.navigate(['/dashboard']);
  }
  showDiv() {
    this.isShow = true;
  }
  PrepareDeclarationData() {
    var declarationData = {
      FormType: "",
      FormSubType: "",
      ContractNummer: "",
      AccountNumber: "",
      User: 0,
      dataXML: {
        XMLFile: {
          Header:
          {
            QualCiv: "",
            Nom: "",
            Prenom: "",
            NoClient: 0,
            RegimeLinguistique: "",
            Email: "",
            Rue: "",
            NoRue: "",
            CodePostal: 0,
            Localite: "",
            LibellePays: ""
          },
          Declaration: [
            {
              Comment: "",
              contrat: [],
              Exercice: 0,
              PeriodeDebut: "",
              PeriodeFin: "",
              NoDeclaration: 0,
              NoProgressif: 0,
              Genre: "",
              noIntervenantDestinataire: 0,
              NomDestinataire: "",
              PrenomDestinataire: "",
              RoleDestinataire: "",
              Statut: "",
              Libelle: "",
              CodeMontantBrut: "",
              MontantBrut: 0,
              CodeMontantNet: '',
              MontantNet: 0,
              CodeMontantTVA: '',
              MontantTVA: 0,
              TVAApplicable: 0,
              CodeActivite: "",
              Activite: [],
              CodePourcentTot: 0,
              independant: [{
                NbrIndependantTot: 0,
                CodeIndependantTot: "",
                NbrAidantTot: 0,
                CodeAidantTot: "",
                signaletique: []
              }
              ],
              LastModifiedDate : "",
              UploadedDocument:[]
            }
          ]
        }
      }
    }

    declarationData.dataXML.XMLFile.Header.NoClient = parseInt(sessionStorage.getItem('ClientNo'));
    declarationData.dataXML.XMLFile.Header.Email = sessionStorage.getItem('NewEmail') != null ? sessionStorage.getItem('NewEmail'):sessionStorage.getItem('Email');
    declarationData.dataXML.XMLFile.Header.CodePostal = this.clientsData.CodePostal;
    declarationData.dataXML.XMLFile.Header.LibellePays = this.clientsData.LibellePays;
    declarationData.dataXML.XMLFile.Header.Localite = this.clientsData.Localite;
    declarationData.dataXML.XMLFile.Header.Rue = this.clientsData.Rue;
    declarationData.dataXML.XMLFile.Header.NoRue = this.clientsData.NoRue;
    declarationData.dataXML.XMLFile.Header.QualCiv = this.clientsData.QualCiv;
    declarationData.dataXML.XMLFile.Header.RegimeLinguistique = this.clientsData.RegimeLinguistique;
    declarationData.dataXML.XMLFile.Header.Nom = this.clientsData.Nom;
    declarationData.dataXML.XMLFile.Header.Prenom = this.clientsData.Prenom;
    // Prepare DECLARATION Data -
    declarationData.FormType = 'DECL_ON_2020';
    declarationData.FormSubType = 'FORM'; //: FORMX/DECL number/ progressif /genre 
    declarationData.ContractNummer = '';//yet to get : Branch "/" Contract number” 
    declarationData.AccountNumber = sessionStorage.getItem('ClientNo'); //d.	(NoClient=No matricule of the client
    declarationData.User = 0; //yet to get from -  RetrieveDeclarationParClient
    declarationData.dataXML.XMLFile.Declaration[0].Comment = this.remarks != undefined ? this.remarks.toString() : "";
    declarationData.dataXML.XMLFile.Declaration[0].Genre = "6";
    declarationData.dataXML.XMLFile.Declaration[0].LastModifiedDate = formatDate(this.today, 'dd/MM/yyyy', 'en-US', '+0100');
    declarationData.dataXML.XMLFile.Declaration[0].Exercice = parseInt(sessionStorage.getItem("Year"));
    declarationData.dataXML.XMLFile.Declaration[0].noIntervenantDestinataire = this.Form6Data.noIntervenantDestinataire;
    declarationData.dataXML.XMLFile.Declaration[0].RoleDestinataire = this.Form6Data.RoleDestinataire;
    declarationData.dataXML.XMLFile.Declaration[0].NoDeclaration = this.Form6Data.NoDeclaration;
    declarationData.dataXML.XMLFile.Declaration[0].NomDestinataire = this.Form6Data.NomDestinataire;
    declarationData.dataXML.XMLFile.Declaration[0].NoProgressif = this.Form6Data.NoProgressif;
    declarationData.dataXML.XMLFile.Declaration[0].PeriodeDebut = this.Form6Data.PeriodeDebut == null ? "" :
      (this.Form6Data.PeriodeDebut.length == 10 ? this.Form6Data.PeriodeDebut : this.customDateFormat(this.Form6Data.PeriodeDebut));
    declarationData.dataXML.XMLFile.Declaration[0].PeriodeFin = this.Form6Data.PeriodeFin == null ? "" :
      (this.Form6Data.PeriodeFin.length == 10 ? this.Form6Data.PeriodeFin : this.customDateFormat(this.Form6Data.PeriodeFin));
    declarationData.dataXML.XMLFile.Declaration[0].Statut = "ACTIVE";

    var contractData = [];
      this.Form6Data.contrat.forEach(element => {
        contractData.push(element);
      });
    declarationData.dataXML.XMLFile.Declaration[0].contrat = contractData;
   
    this.uploadedFilesList.forEach(item => {
      var requestObj = {
        Locale:"",
        Bytes: "",
        FilePath: "",
        FileName: ""
      }
      requestObj.FileName = item.FileName;
      requestObj.FilePath = item.FilePath;
      requestObj.Locale = "1";
      declarationData.dataXML.XMLFile.Declaration[0].UploadedDocument.push(requestObj);
    });
   
    if (this.FormsData !== null) {
      this.FormsData.forEach(element => {
        if (element.Genre != "6") {
          declarationData.dataXML.XMLFile.Declaration.push(element);
        }
      });
    }
    this.FormsData = declarationData.dataXML.XMLFile.Declaration;
    this.finaldeclarationData = declarationData;
  }
  formatDate(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
        return [year, month, day].join('-');
      } else if (date.length == 8) {
        var year = date.substring(0, 4);
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
        return [year, month, day].join('-');
      }

    } else {
      return null;
    }
  }
  customDateFormat(date) {
    if (date !== '' && date !== null) {
      if (date.length == 19) {
        var year = date.substring(0, 4);
        var month = date.substring(7, 5);
        var day = date.substring(10, 8);
      } else if (date.length == 8) {
        var year = date.substring(0, 4); 
        var month = date.substring(6, 4);
        var day = date.slice(date.length - 2);
      }

      return [day ,month, year].join('/');
    } else {
      return null;
    }
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("selectedFormData");
  }
}
